import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const catalogExplorerPlugin = createPlugin({
  id: 'catalog-explorer',
  routes: {
    root: rootRouteRef,
  },
});

export const ServiceCatalogExplorerPage = catalogExplorerPlugin.provide(
  createRoutableExtension({
    name: 'ServiceCatalogExplorerPage',
    component: () =>
      import(
        './components/CatalogExplorerPage/ServiceCatalogExplorerPage'
      ).then(m => m.ServiceCatalogExplorerPage),
    mountPoint: rootRouteRef,
  }),
);

export const SupervisoryOrgExplorerPage = catalogExplorerPlugin.provide(
  createRoutableExtension({
    name: 'SupervisoryOrgExplorerPage',
    component: () =>
      import(
        './components/CatalogExplorerPage/SupervisoryOrgExplorerPage'
      ).then(m => m.SupervisoryOrgExplorerPage),
    mountPoint: rootRouteRef,
  }),
);

export const DaaSCatalogExplorerPage = catalogExplorerPlugin.provide(
  createRoutableExtension({
    name: 'DaaSCatalogExplorerPage',
    component: () =>
      import('./components/CatalogExplorerPage/DaaSCatalogExplorerPage').then(
        m => m.DaaSCatalogExplorerPage,
      ),
    mountPoint: rootRouteRef,
  }),
);

export const AIToolsCatalogExplorerPage = catalogExplorerPlugin.provide(
  createRoutableExtension({
    name: 'AIToolsCatalogExplorerPage',
    component: () =>
      import(
        './components/CatalogExplorerPage/AIToolsCatalogExplorerPage'
      ).then(m => m.AIToolsCatalogExplorerPage),
    mountPoint: rootRouteRef,
  }),
);

export const ProxyCatalogExplorerPage = catalogExplorerPlugin.provide(
  createRoutableExtension({
    name: 'ProxyCatalogExplorerPage',
    component: () =>
      import('./components/CatalogExplorerPage/ProxyCatalogExplorerPage').then(
        m => m.ProxyCatalogExplorerPage,
      ),
    mountPoint: rootRouteRef,
  }),
);

export const ApplicationCatalogExplorerPage = catalogExplorerPlugin.provide(
  createRoutableExtension({
    name: 'ApplicationCatalogExplorerPage',
    component: () =>
      import(
        './components/CatalogExplorerPage/ApplicationCatalogExplorerPage'
      ).then(m => m.ApplicationCatalogExplorerPage),
    mountPoint: rootRouteRef,
  }),
);

export const RepositoryExplorerPage = catalogExplorerPlugin.provide(
  createRoutableExtension({
    name: 'RepositoryExplorerPage',
    component: () =>
      import('./components/CatalogExplorerPage/RepositoryExplorerPage').then(
        m => m.RepositoryExplorerPage,
      ),
    mountPoint: rootRouteRef,
  }),
);

export const UserCatalogExplorerPage = catalogExplorerPlugin.provide(
  createRoutableExtension({
    name: 'UserCatalogExplorerPage',
    component: () =>
      import('./components/CatalogExplorerPage/UserCatalogExplorerPage').then(
        m => m.UserExplorerPage,
      ),
    mountPoint: rootRouteRef,
  }),
);

export const JiraTeamsExplorerPage = catalogExplorerPlugin.provide(
  createRoutableExtension({
    name: 'JiraTeamsExplorerPage',
    component: () =>
      import('./components/CatalogExplorerPage/JiraTeamsExplorerPage').then(
        m => m.JiraTeamsExplorerPage,
      ),
    mountPoint: rootRouteRef,
  }),
);

export const PagerDutyTeamsExplorerPage = catalogExplorerPlugin.provide(
  createRoutableExtension({
    name: 'PagerDutyTeamsExplorerPage',
    component: () =>
      import(
        './components/CatalogExplorerPage/PagerDutyTeamsExplorerPage'
      ).then(m => m.PagerDutyTeamsExplorerPage),
    mountPoint: rootRouteRef,
  }),
);

export const SubscriptionCatalogExplorerPage = catalogExplorerPlugin.provide(
  createRoutableExtension({
    name: 'SubscriptionCatalogExplorerPage',
    component: () =>
      import(
        './components/CatalogExplorerPage/SubscriptionCatalogExplorerPage'
      ).then(m => m.SubscriptionCatalogExplorerPage),
    mountPoint: rootRouteRef,
  }),
);

export const KubernetesCatalogExplorerPage = catalogExplorerPlugin.provide(
  createRoutableExtension({
    name: 'KubernetesCatalogExplorerPage',
    component: () =>
      import(
        './components/CatalogExplorerPage/KubernetesCatalogExplorerPage'
      ).then(m => m.KubernetesCatalogExplorerPage),
    mountPoint: rootRouteRef,
  }),
);
